import request from "../../utils/request";

// 获取需要显示的项目
export function getPtype(authorization) {
  return request({
    url: "/api/hmcpotentialdemand/selectptypebycorpId",
    method: "get",
    headers: {
      authorization: authorization,
    },
  });
}

// 保存显示项目类型
export function savePtype(authorization, data) {
  return request({
    url: "/api/hmcpotentialdemand/insertorupdatedemand",
    method: "post",
    data,
    headers: {
      authorization: authorization,
    },
  });
}

// 获取基础设置详情
export function getQySetting(authorization) {
  return request({
    url: "/api/QYSetting/getQySetting",
    method: "get",
    headers: {
      authorization: authorization,
    },
  });
}

// 审批设置
export function updateQYApprove(params, authorization) {
  return request({
    url: "/api/QYSetting/updateQYApprove",
    method: "PUT",
    data: params,
    headers: {
      authorization: authorization,
    },
  });
}

// 转让所有者
export function transferAdmin(params, authorization) {
  return request({
    url: "/api/QYSetting/transferAdmin",
    method: "post",
    data: params,
    headers: {
      authorization: authorization,
    },
  });
}

// 下载 /api/qywechat/tools/download
export function getDownLoad(authorization) {
  return request({
    url: "/api/qywechat/tools/download",
    method: "get",
    headers: {
      authorization: authorization,
    },
  });
}

// 保存发送报告
export function reportSave(authorization, data, isloading = false) {
  return request(
    {
      url: "/api/report/save",
      method: "post",
      data,
      headers: {
        authorization: authorization,
      },
    },
    isloading
  );
}

// 获取发送报告
export function getReport(authorization) {
  return request({
    url: "/api/report/getsetting",
    method: "get",
    headers: {
      authorization: authorization,
    },
  });
}

// 获取业绩数据
export function getReportData(authorization, data) {
  return request({
    url: "/api/report/reportdata",
    method: "get",
    params: data,
    headers: {
      authorization: authorization,
    },
  });
}

// 获取分院机构
export function getEarInfoList(authorization) {
  return request({
    url: "/api/report/selectearinfolist",
    method: "get",
    headers: {
      authorization: authorization,
    },
  });
}

/** 标签同步 后台调用 */
export function tagSyncTagApi(authorization) {
  return request({
    url: "/api/qywechat/tag/syncTag",
    method: "post",
    headers: {
      authorization: authorization,
    },
  });
}

/** 校验时间 true 表示在15分钟内不允许再次请求 */
export function checkTimeApi(authorization) {
  return request({
    url: "/api/qywechat/tag/checkTime",
    method: "get",
    headers: {
      authorization: authorization,
    },
  });
}

/** 新增好友预警推送职员 */
export function addStaffApi(authorization, data, isloading = false) {
  return request(
    {
      url: "/api/qywechat/sidebar/message/addStaff",
      method: "post",
      data,
      headers: {
        authorization: authorization,
      },
    },
    isloading
  );
}

/** 好友预警应用消息详情 */
export function messageStaffListApi(authorization, isloading = false) {
  return request(
    {
      url: "/api/qywechat/sidebar/message/staffList",
      method: "get",
      headers: {
        authorization: authorization,
      },
    },
    isloading
  );
}
